<template>
  <div class="foot" style="height:106px" :style="getBjtp1('soldbj.png')">

<!-- <img :src="fileServerUrl + 'assets/bg/soldbj.png'" /> -->

    <!-- <div class="five-col">

      <div class="col-item" style="margin-left: 2%">
        <img :src="fileServerUrl + 'assets/sold/soldlogo.png'" />

        <div class="qx">
          <span>{{ $t("footer1") }}</span>
          <i
            class="iconfont icon-arrowRight"
            style="font-size: 0.1rem; margin-left: 11%"
          ></i>
        </div>
      </div>
      <div class="col-item">
        <span class="col-title">{{ $t("footer2") }}</span>

        <div style="margin-top: 10%" class="hover-color hover-d">
          <span style="line-height: 27px">{{ $t("footer3") }} </span>
        </div>

        <span class="mail hover-color hover-d">{{ $t("footer4") }}</span>
      </div>
      <div class="col-item">
        <span class="col-title">{{ $t("footer5") }}</span>

        <a
          href="http://www.huiyuexpo.com/#/"
          target="_blank"
          style="color: #cccccc"
          class="hover-color hover-d gy-height"
          >{{ $t("footer6") }}</a
        >
        <span class="hover-color hover-d gy-height">{{ $t("footer7") }}</span>
      </div>
      <div class="col-item">
        <span class="col-title">{{ $t("footer8") }}</span>

        <a
          href="http://www.logtalk.huiyuexpo.com/#/"
          target="_blank"
          style="margin-top: 10%; color: #cccccc"
          class="gy-height hover-color hover-d"
          >LogTalk 2023</a
        >
        <span class="gy-height hover-color hover-d">MTech 2023</span>
        <a
          href="http://www.itall.tech/#/"
          target="_blank"
          class="gy-height hover-color hover-d"
          style="color: #cccccc"
          >iTall 2023</a
        >
      </div>
      <div class="col-item">
        <span class="col-title">{{ $t("footer9") }}</span>
        <span
          @click="join"
          style="margin-top: 10%"
          class="hover-color hover-d"
          >{{ $t("footer10") }}</span
        >
        <span class="gy-height hover-color hover-d">{{ $t("footer11") }}</span>
        <span @click="speak" class="gy-height hover-color hover-d">{{
          $t("footer12")
        }}</span>
        <span
          style="margin-bottom: 10%"
          @click="sponsor"
          class="gy-height hover-color hover-d"
          >{{ $t("footer13") }}</span
        >
        <el-popover
          placement="top-start"
          content="+86 21 6125 8698"
          trigger="click"
        >
          <span slot="reference" class="hover-color hover-d">{{
            $t("footer14")
          }}</span>
        </el-popover>
      </div>

    </div>-->
    <div class="dibu" style="text-align:center;height:50px;padding-top:50px">

      <img style="width: 55px; margin-right:30px" :src="fileServerUrl + 'assets/sold/soldlogo.png'" />

      <span class="hover-color hover-d">
        © 2026 HUIYU EXHIBITION (SHANGHAI) CO.,LTD.
        &nbsp;会誉会展（上海）有限公司</span
      >

      <a
        style="margin-left: 5%"
        target="_blank"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702007599"
      >
        沪公网安备 31010702007599号
      </a>

      <a href="https://beian.miit.gov.cn/" style="margin-left: 2%"
        >沪ICP备&nbsp;2020038301号-4</a
      >
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      fileServerUrl: fileServerUrl,
    };
  },
  methods: {
    join() {
      this.$router.push("/hyticket");
    },
    speak() {
      document.querySelector("#yjjb").scrollIntoView(true);
    },
    sponsor() {
      this.$router.push("/whysponsor");
    },
    getBjtp1(name) {
      let ys = {
        backgroundImage:
          "url(" + this.fileServerUrl + "assets/bg/" + name + ")",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        // backgroundColor:'#524AF6FF',
        backgroundPosition: "center",
      };
      return ys;
    },
  },
};
</script>

<style lang="scss" scoped>
.foot {
  width: 100%;
  height: 210px;
  color: #fff;
  background-color: #1b1f2b;
}

.five-col {
  margin-left: 3%;
  display: flex;
  //border: 0.1px solid red;
  justify-content: space-between;
}

.col-item {
  //border: 0.1px solid red;
  width: 128px;

  display: flex;
  flex-direction: column;
  margin-top: 2%;

  //border: 0.1px solid deepskyblue;

  font-size: 0.084rem;

  color: #cccccc;

  font-family: "PingFang SC";

  img {
    width: 55px;
    height: 8px;
    margin-top: 11%;
  }
}

.qx {
  width: 52px;
  font-size: 0.1rem;
  font-family: weiruan;
  margin-top: 20%;
  display: flex;
  height: 20px;
  color: white;
  border-bottom: 0.1px solid #fff;
  cursor: pointer;
  align-items: center;
  //border: 0.1px solid #42e7fe;
}

.qx:hover {
  color: #cccccc;
  border-bottom: 0.1px solid #dedede;
}

.dz-info {
  cursor: pointer;
  margin-top: 10%; //首个间距
  line-height: 12px;
}

.mail {
  margin-top: 10%;
  cursor: pointer;
}

.dibu {
  // display: flex;

  //border: 0.1px solid red;
  font-size: 0.082rem;
  font-family: "SansSerif";
  color: #cccccc;
  // margin-left: 9%;
  // margin-top: 6%;

  a {
    color: #cccccc;
  }
  a:hover {
    color: white;
    cursor: pointer;
  }
}

//公用样式
.col-title {
  font-family: SansSerif;
  font-weight: bold;
  font-size: 0.1rem;
  margin-top: 10%;
  color: #fff;
}

.hover-d {
  cursor: pointer;
}

.hover-color:hover {
  color: #ffff;
}

.gy-height {
  margin-top: 10%;
}
</style>
